//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { NsIcon } from '@nuskin/ns-icon';

export default {
  name: 'NsCheckbox',
  components: {
    NsIcon,
  },
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
    iconName: {
      type: String,
      default: 'icon-checkmark',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 24,
    },
    /**
     * Indicates if the checkbox is checked.
     */
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
